import { Paper, PaperProps } from "@mui/material";
import { memo, useRef } from "react";
import Draggable from "react-draggable";
import { DEFAULT_DRAG_HANDLE_SELECTOR } from "../../../../app/constants";

interface DraggablePaperProps extends PaperProps {
  dragHandleSelector?: string;
  disabled: boolean;
}

const DraggablePaper = memo(
  ({
    dragHandleSelector = DEFAULT_DRAG_HANDLE_SELECTOR,
    disabled,
    ...props
  }: DraggablePaperProps) => {
    // drag handle selector is always a class
    const dragHandleSelectorClass = `.${dragHandleSelector}`;

    // fix console warning: "Warning: findDOMNode is deprecated in StrictMode."
    const nodeRef = useRef(null);

    return (
      <Draggable
        nodeRef={nodeRef}
        handle={dragHandleSelectorClass}
        cancel=".MuiButton-root, .no-drag"
        disabled={disabled}
      >
        <Paper ref={nodeRef} {...props} />
      </Draggable>
    );
  },
);

export default DraggablePaper;
